import { Button, Form, Input, message, Row, Typography } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import OrganismLoginLayout from "../../components/organism/login-layout";
import {
  generateErrorMessage,
  sendPostRequest,
} from "../../services/request-adapter";
import {
  getUserPermission,
  setAuthToken,
  setLoginStatus,
  setRefreshToken,
} from "../../stores/auth/actions";

const { Text } = Typography;

const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { deviceTokenFcm } = useSelector((state) => state.auth);

  const [isLoggingIn, setisLoggingIn] = useState(false);
  const [input, setInput] = useState({ email: "", password: "" });

  const handleChange = (e) => {
    setInput({ ...input, [e.target.name]: e.target.value });
  };
  const sendDeviceToken = async () => {
    //
    // console.log(deviceTokenFcm)
    try {
      await sendPostRequest("/user-devices", { device_key: deviceTokenFcm });
    } catch (error) {
      console.error(error);
    }
  };

  const onFinish = async (values) => {
    let params = {
      email: values.email,
      username: values.email,
      password: values.password,
      grant_type: "password",
      client_id: process.env.REACT_APP_CLIENT_ID,
      client_secret: process.env.REACT_APP_CLIENT_SERVICE,
    };

    setisLoggingIn(true);
    try {
      const { data } = await sendPostRequest("/oauth/token", params);

      // console.log(data.type_user)

      // if(data.type_user === 0 || data.type_user === 1) {
      dispatch(setAuthToken(data.access_token));
      dispatch(setRefreshToken(data.refresh_token));
      dispatch(setLoginStatus(true));
      navigate("/", { replace: true });
      await sendDeviceToken();
      // } else {
      //   message.error('User not authorized')
      // }
    } catch (error) {
      message.error(generateErrorMessage(error));
    } finally {
      setisLoggingIn(false);
    }
  };

  return (
    <OrganismLoginLayout
      title="Welcome Back!"
      text="Please login to access the admin panel"
    >
      <Form
        layout="vertical"
        name="login"
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          style={{
            fontWeight: 500,
          }}
          label="Email"
          name="email"
          rules={[
            // { type: "email" },
            {
              required: true,
              message: "Please input your registered email!",
            },
          ]}
        >
          <Input
            size="large"
            name="email"
            autoFocus={true}
            placeholder="Input your registered email"
            value={input.email}
            onChange={(e) => handleChange(e)}
          />
        </Form.Item>

        <Form.Item
          style={{
            fontWeight: 500,
          }}
          label="Password"
          name="password"
          rules={[
            {
              required: true,
              message: "Please input your account password!",
            },
          ]}
        >
          <Input.Password
            size="large"
            name="password"
            placeholder="Input your account password"
            value={input.password}
            onChange={(e) => handleChange(e)}
          />
        </Form.Item>

        <Row justify="end" style={{ marginBottom: "1rem" }}>
          <Text
            onClick={() => navigate("/forgot-password")}
            type="secondary"
            className="pointer fs-12"
          >
            Forgot Password
          </Text>
        </Row>
        <Form.Item>
          <Button
            block
            disabled={input.email === "" || input.password === ""}
            type="primary"
            htmlType="submit"
            size="large"
            loading={isLoggingIn}
          >
            <b>Login</b>
          </Button>
        </Form.Item>
      </Form>
    </OrganismLoginLayout>
  );
};

export default LoginPage;
